// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"Tabs_Tabs__5Fqyc","active":"Tabs_active__MbPmC"};